import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type { IApiDeleteCategoryResponseBody } from '../CategoriesApi.types';
import { useApi } from '~/lib/api/useApi';
import { categoriesQueryKeyFactory } from './useCategoriesQuery';
import { categoryQueryKeyFactory } from './useCategoryQuery';

export type IUseDeleteCategoryMutationValues = {
  appId: string;
  categoryId: string;
};

export const useDeleteCategoryMutation = (): UseMutationResult<
  IApiDeleteCategoryResponseBody,
  unknown,
  IUseDeleteCategoryMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseDeleteCategoryMutationValues) =>
      api.categories.delete(values.appId, values.categoryId),
    onSuccess: async (_, values) => {
      // TODO once the API is updated to return the deleted resources
      // data.deletedResources.categoryIds
      [values.categoryId]
        .map((categoryId) => [
          {
            queryKey: categoryQueryKeyFactory({
              appId: values.appId,
              categoryId,
            }),
          },
        ])
        .flat()
        .forEach((filters) => queryClient.removeQueries(filters));

      await queryClient.invalidateQueries({
        queryKey: categoriesQueryKeyFactory({ appId: values.appId }),
      });
    },
  });
};
